'use strict'; // https://github.com/tc39/proposal-iterator-helpers

var $ = require('../internals/export');

var iterate = require('../internals/iterate');

var anObject = require('../internals/an-object');

var push = [].push;
$({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  toArray: function toArray() {
    var result = [];
    iterate(anObject(this), push, {
      that: result,
      IS_ITERATOR: true
    });
    return result;
  }
});